import { Dispatcher, } from 'flux';
import { registerInNamespace, } from 'application/nm';

const STATIC_ACTION_SOURCES = ['view', 'server', 'external', 'window'];

class AppDispatcher extends Dispatcher {

  constructor(opts = {}){
    super(opts);
    this.constructor.ACTION_SOURCES = opts.actionSources || [];
    this.actionHandlers = opts.actionHandlers || {};
    STATIC_ACTION_SOURCES.forEach(this.addActionSource, this);
  }

  addActionSource(source){
    this.constructor.ACTION_SOURCES.push(source);
    this.actionHandlers[source] = this.handleAction.bind(this, source);
    return this;
  }

  handleAction(source, action){
    this.dispatch(Object.assign({ source }, action));
    return this;
  }

  get dispatchAction(){
    return this.actionHandlers;
  }

  static get STATIC_ACTION_SOURCES(){ return STATIC_ACTION_SOURCES; }

}

let appDispatcher = new AppDispatcher();

registerInNamespace({ appDispatcher, });

export default appDispatcher;



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/application/AppDispatcher.js